export const googleLoginSuccess = (payload, userInfo) => {
  return {
    type: "GOOGLE_LOGIN_SUCCESS",
    payload,
    userInfo
  };
}

export const googleLoginFail = (payload) => {
  return {
    type: "GOOGLE_LOGIN_FAIL",
  };
}
